
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.5.78l11.195 11.363h-4.771l3.279 5.018-3.38 2.028-3.428-5.877L5.5 16.207V.78zm1 2.44v10.573l2.105-2.105 3.572 6.123 1.62-.973-3.72-5.695h4.229L6.5 3.22z","fill":"#303133"}})])
          )
        }
      }
    